module.exports = __webpack_public_path__ + "22c8127b0efb696cb451a8922fe76694.MP3";